import {
  UPDATE_RESIZE_VALUES,
  TOGGLE_RESIZE_RATIO_LOCK,
  SET_RESIZE_CHANGED_STATUS,
  SET_RESIZE_MODAL,
  SET_RESIZE_REDIRECT,
} from '../types/resize.types'

export const updateResizeValues = (data) => ({ type: UPDATE_RESIZE_VALUES, payload: data })
export const toggleResizeRatioLock = (data) => ({ type: TOGGLE_RESIZE_RATIO_LOCK, payload: data })
export const setResizeChangedStatus = (status) => ({ type: SET_RESIZE_CHANGED_STATUS, payload: status })
export const setResizeModal = (status) => ({ type: SET_RESIZE_MODAL, payload: status })
export const setResizeRedirect = (to) => ({ type: SET_RESIZE_REDIRECT, payload: to })
